import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.getClasses.wrap)
        }, [
          (Array.isArray(_ctx.title))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_ctx.getClasses.bd)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.title, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    class: _normalizeClass(_ctx.getClasses.title)
                  }, _toDisplayString(item), 3))
                }), 128))
              ], 2))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(_ctx.getClasses.bd)
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.getClasses.title)
                }, _toDisplayString(_ctx.title), 3)
              ], 2))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}